import { render, staticRenderFns } from "./scorerecordcheck.vue?vue&type=template&id=5d578a48&scoped=true"
import script from "./scorerecordcheck.vue?vue&type=script&lang=js"
export * from "./scorerecordcheck.vue?vue&type=script&lang=js"
import style0 from "./scorerecordcheck.vue?vue&type=style&index=0&id=5d578a48&prod&scoped=scoped&lang=css"
import style1 from "./scorerecordcheck.vue?vue&type=style&index=1&id=5d578a48&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d578a48",
  null
  
)

export default component.exports